import http from '@/utils/http';
import { fetchCondConfigs } from '@intelligence/v3/services/common';
import {
  ALINEA_CALIBRATION_COND_KEY,
  ALINEA_CALIBRATION_REGION_TARGET,
} from './constants';

import type { IAlineaCalibrationListParams, IAlineaCalibrationListResponse } from './types';

export const fetchAlineaCalibrationRegionCodes = async (): Promise<string[]> => {
  const res = await fetchCondConfigs({
    [ALINEA_CALIBRATION_COND_KEY]: {
      target: ALINEA_CALIBRATION_REGION_TARGET,
      params: {},
    },
  });
  const data = res?.data;
  const list = data?.[ALINEA_CALIBRATION_COND_KEY] || data;

  if (Array.isArray(list)) {
    return list.filter((item) => {
      return typeof item === 'string' && item.trim();
    });
  }

  return [];
};

export const fetchAlineaCalibrationList = (
  params: IAlineaCalibrationListParams,
): Promise<IAlineaCalibrationListResponse> => {
  return http({
    url: '/api/v1/intelligence_pc/topcharts_list',
    method: 'post',
    data: params,
    rawData: true,
  }) as Promise<IAlineaCalibrationListResponse>;
};
